import { useRecoilValue } from 'recoil';
import { getStatisticForecast } from '../../atoms/Forecast';

export const getRollingWeeksLabel = (numberOfWeeks) => {
  if (!numberOfWeeks) return `Rolling Weeks`;
  return `Rolling ${numberOfWeeks} Weeks`;
};

export const useRollingWeeksLabel = () => {
  const statisticData = useRecoilValue(getStatisticForecast);
  return getRollingWeeksLabel(statisticData?.numberOfWeeks);
};
